module.exports = __webpack_public_path__ + "static/media/lemoncode.0ac3e8c1.png";